import { render, staticRenderFns } from "./CATab.vue?vue&type=template&id=6852095d&"
import script from "./CATab.vue?vue&type=script&lang=js&"
export * from "./CATab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports